"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerspectiveDisplay = exports.PerspectiveDisplayRow = exports.PerspectiveDisplayColumn = void 0;
const max_1 = __importDefault(require("lodash/max"));
const fill_1 = __importDefault(require("lodash/fill"));
const findIndex_1 = __importDefault(require("lodash/findIndex"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const debug_1 = __importDefault(require("debug"));
const dbg = (0, debug_1.default)('dbgate:PerspectiveDisplay');
let lastJoinId = 0;
function getJoinId() {
    lastJoinId += 1;
    return lastJoinId;
}
class PerspectiveDisplayColumn {
    constructor(display) {
        this.display = display;
        this.parentNodes = [];
        this.colSpanAtLevel = {};
        this.columnIndex = 0;
        this.dataNode = null;
    }
    get rowSpan() {
        return this.display.columnLevelCount - this.parentNodes.length;
    }
    showParent(level) {
        return !!this.colSpanAtLevel[level];
    }
    getColSpan(level) {
        return this.colSpanAtLevel[level];
    }
    isVisible(level) {
        return level == this.columnLevel;
    }
    get columnLevel() {
        return this.parentNodes.length;
    }
    getParentName(level) {
        var _a;
        return (_a = this.parentNodes[level]) === null || _a === void 0 ? void 0 : _a.title;
    }
    getParentNode(level) {
        return this.parentNodes[level];
    }
    getParentTableDesignerId(level) {
        var _a, _b;
        return ((_a = this.parentNodes[level]) === null || _a === void 0 ? void 0 : _a.headerTableAttributes) ? (_b = this.parentNodes[level]) === null || _b === void 0 ? void 0 : _b.designerId : '';
    }
}
exports.PerspectiveDisplayColumn = PerspectiveDisplayColumn;
class PerspectiveDisplayRow {
    constructor(display) {
        this.display = display;
        this.rowData = [];
        this.rowSpans = null;
        this.rowCellSkips = null;
        this.rowJoinIds = [];
        this.rowData = (0, fill_1.default)(Array(display.columns.length), undefined);
        this.rowSpans = (0, fill_1.default)(Array(display.columns.length), 1);
        this.rowJoinIds = (0, fill_1.default)(Array(display.columns.length), 0);
        this.rowCellSkips = (0, fill_1.default)(Array(display.columns.length), false);
    }
}
exports.PerspectiveDisplayRow = PerspectiveDisplayRow;
class PerspectiveDisplay {
    constructor(root, rows) {
        this.root = root;
        this.columns = [];
        this.rows = [];
        this.loadIndicatorsCounts = {};
        // dbg('source rows', rows);
        this.fillColumns(root.childNodes, [root]);
        if (this.columns.length > 0) {
            this.columns[0].colSpanAtLevel[0] = this.columns.length;
        }
        this.columnLevelCount = (0, max_1.default)(this.columns.map(x => x.parentNodes.length)) + 1;
        const collectedRows = this.collectRows(rows, root.childNodes);
        dbg('collected rows', collectedRows);
        // console.log('COLLECTED', JSON.stringify(collectedRows, null, 2));
        // this.mergeRows(collectedRows);
        this.mergeRows(collectedRows);
        // dbg('merged rows', this.rows);
        // console.log(
        //   'MERGED',
        //   this.rows.map(r =>
        //     r.incompleteRowsIndicator
        //       ? `************************************ ${r.incompleteRowsIndicator.join('|')}`
        //       : r.rowData.join('|')
        //   )
        // );
    }
    getRowAt(rowIndex) {
        while (this.rows.length <= rowIndex) {
            this.rows.push(new PerspectiveDisplayRow(this));
        }
        return this.rows[rowIndex];
    }
    fillColumns(children, parentNodes) {
        for (const child of children) {
            if (child.generatesHiearchicGridColumn || child.generatesDataGridColumn) {
                this.processColumn(child, parentNodes);
            }
        }
    }
    processColumn(node, parentNodes) {
        var _a, _b;
        if (node.generatesDataGridColumn) {
            const column = new PerspectiveDisplayColumn(this);
            column.title = node.columnTitle;
            column.dataField = node.dataField;
            column.parentNodes = parentNodes;
            column.display = this;
            column.columnIndex = this.columns.length;
            column.dataNode = node;
            column.displayType = (_b = (_a = node.parentNodeConfig) === null || _a === void 0 ? void 0 : _a.columnDisplays) === null || _b === void 0 ? void 0 : _b[node.columnName];
            this.columns.push(column);
        }
        if (node.generatesHiearchicGridColumn) {
            const countBefore = this.columns.length;
            this.fillColumns(node.childNodes, [...parentNodes, node]);
            if (this.columns.length > countBefore) {
                this.columns[countBefore].colSpanAtLevel[parentNodes.length] = this.columns.length - countBefore;
            }
        }
    }
    findColumnIndexFromNode(node) {
        return (0, findIndex_1.default)(this.columns, x => { var _a, _b, _c; return x.dataNode.columnName == node.columnName && ((_b = (_a = x.dataNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.designerId) == ((_c = node === null || node === void 0 ? void 0 : node.parentNode) === null || _c === void 0 ? void 0 : _c.designerId); });
    }
    // findColumnIndexFromNode(node: PerspectiveTreeNode) {
    //   return _findIndex(this.columns, x => x.dataNode.designerId == node.designerId);
    // }
    extractArray(value) {
        if ((0, isArray_1.default)(value))
            return value;
        if ((0, isPlainObject_1.default)(value))
            return [value];
        return [];
    }
    collectRows(sourceRows, nodes) {
        // console.log('********** COLLECT ROWS', sourceRows);
        const columnNodes = nodes.filter(x => x.generatesDataGridColumn);
        const treeNodes = nodes.filter(x => x.generatesHiearchicGridColumn);
        // console.log(
        //   'columnNodes',
        //   columnNodes.map(x => x.title)
        // );
        // console.log(
        //   'treeNodes',
        //   treeNodes.map(x => x.title)
        // );
        // console.log(
        //   'nodes',
        //   nodes.map(x => x.title)
        // );
        const columnIndexes = columnNodes.map(node => this.findColumnIndexFromNode(node));
        const res = [];
        for (const sourceRow of sourceRows) {
            // console.log('PROCESS SOURCE', sourceRow);
            // row.startIndex = startIndex;
            const rowData = columnNodes.map(node => sourceRow[node.columnName]);
            const subRowCollections = [];
            for (const node of treeNodes) {
                // console.log('sourceRow[node.fieldName]', node.fieldName, sourceRow[node.fieldName]);
                if (sourceRow[node.fieldName]) {
                    const subrows = {
                        rows: this.collectRows(this.extractArray(sourceRow[node.fieldName]), node.childNodes),
                    };
                    subRowCollections.push(subrows);
                }
            }
            res.push({
                rowData,
                columnIndexes,
                subRowCollections,
                incompleteRowsIndicator: sourceRow.incompleteRowsIndicator,
            });
        }
        return res;
    }
    fillRowSpans() {
        for (let col = 0; col < this.columns.length; col++) {
            // let lastFilledJoinId = null;
            let lastFilledRow = 0;
            let rowIndex = 0;
            for (const row of this.rows) {
                if (row.rowData[col] === undefined &&
                    row.rowJoinIds[col] == this.rows[lastFilledRow].rowJoinIds[col] &&
                    row.rowJoinIds[col]) {
                    row.rowCellSkips[col] = true;
                    this.rows[lastFilledRow].rowSpans[col] = rowIndex - lastFilledRow + 1;
                }
                else {
                    lastFilledRow = rowIndex;
                }
                rowIndex++;
            }
        }
    }
    mergeRows(collectedRows) {
        let rowIndex = 0;
        for (const collectedRow of collectedRows) {
            const count = this.mergeRow(collectedRow, rowIndex);
            rowIndex += count;
        }
        this.fillRowSpans();
    }
    mergeRow(collectedRow, rowIndex) {
        var _a;
        if (((_a = collectedRow.incompleteRowsIndicator) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            for (const indicator of collectedRow.incompleteRowsIndicator) {
                if (!this.loadIndicatorsCounts[indicator]) {
                    this.loadIndicatorsCounts[indicator] = rowIndex;
                }
                if (rowIndex < this.loadIndicatorsCounts[indicator]) {
                    this.loadIndicatorsCounts[indicator] = rowIndex;
                }
            }
            return 0;
        }
        const mainRow = this.getRowAt(rowIndex);
        for (let i = 0; i < collectedRow.columnIndexes.length; i++) {
            mainRow.rowData[collectedRow.columnIndexes[i]] = collectedRow.rowData[i];
        }
        let rowCount = 1;
        for (const subrows of collectedRow.subRowCollections) {
            let additionalRowCount = 0;
            let currentRowIndex = rowIndex;
            for (const subrow of subrows.rows) {
                const count = this.mergeRow(subrow, currentRowIndex);
                additionalRowCount += count;
                currentRowIndex += count;
            }
            if (additionalRowCount > rowCount) {
                rowCount = additionalRowCount;
            }
        }
        const joinId = getJoinId();
        for (let radd = 0; radd < rowCount; radd++) {
            const row = this.getRowAt(rowIndex + radd);
            for (let i = 0; i < collectedRow.columnIndexes.length; i++) {
                row.rowJoinIds[collectedRow.columnIndexes[i]] = joinId;
            }
        }
        return rowCount;
    }
}
exports.PerspectiveDisplay = PerspectiveDisplay;
